import React, { useRef, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";

function QRWithLogo({ value, logo }) {
  const canvasRef = useRef();

  // Tính toán kích thước QR code dựa trên màn hình
  const qrSize = Math.min(window.innerWidth * 0.8, 320);

  useEffect(() => {
    const qrCode = new window.Image();
    const qrDataUrl = document
      .getElementById("hidden-qr")
      .toDataURL("image/png");
    qrCode.src = qrDataUrl;
    qrCode.onload = () => {
      const ctx = canvasRef.current.getContext("2d");
      ctx.clearRect(0, 0, qrSize, qrSize);
      ctx.drawImage(qrCode, 0, 0, qrSize, qrSize);

      if (logo) {
        const img = new window.Image();
        img.src = logo;
        img.onload = () => {
          const logoSize = qrSize / 6;
          ctx.drawImage(
            img,
            (qrSize - logoSize) / 2,
            (qrSize - logoSize) / 2,
            logoSize,
            logoSize
          );
        };
      }
    };
    // eslint-disable-next-line
  }, [value, logo, qrSize]);

  // Hàm tải ảnh từ canvas
  const handleDownload = () => {
    const canvas = canvasRef.current;
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = "qr_with_logo.png";
    link.click();
  };

  return (
    <div style={{ marginTop: 24, textAlign: "center" }}>
      <QRCodeCanvas
        id="hidden-qr"
        value={value}
        size={qrSize}
        includeMargin={true}
        style={{ display: "none" }}
      />
      <canvas
        ref={canvasRef}
        width={qrSize}
        height={qrSize}
        style={{
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(59,130,246,0.08)",
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <br />
      <button
        onClick={handleDownload}
        style={{
          marginTop: 16,
          padding: "10px 32px",
          background: "#10b981",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 600,
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(16,185,129,0.12)",
          transition: "background 0.2s",
        }}
      >
        Tải về
      </button>
    </div>
  );
}

export default QRWithLogo;